export const ActionTypes = {
  FETCH_MAINTENANCE_DASHBOARD_DATA: 'services/dashboards/maintenance/fetch_maintenance_dashboard_data',
  SET_MAINTENANCE_DASHBOARD_DATA: 'services/dashboards/maintenance/set_maintenance_dashboard_data',
  FETCH_MAINTENANCE_JOBS: 'services/dashboards/maintenance/fetch_maintenance_jobs',
  SET_MAINTENANCE_JOBS: 'services/dashboards/maintenance/set_maintenance_jobs',
  SET_LOADER_STATUS: 'services/dashboards/maintenance/set_loader_status',
  FETCH_FACTORY_LABOURS: 'services/dashboards/maintenance/fetch_factory_labours',
  FETCH_FACTORY_DEPARTMENTS: 'services/dashboards/maintenance/fetch_factory_departments',
  SET_FACTORY_LABOURS: 'services/dashboards/maintenance/set_factory_labours',
  SET_FACTORY_DEPARTMENTS: 'services/dashboards/maintenance/set_factory_departments',
  FETCH_MAINTENANCE_IMAGES_BY_JOB: 'services/dashboards/maintenance/fetch_maintenance_images_by_job',
  SET_MAINTENANCE_IMAGES_BY_JOB: 'services/dashboards/maintenance/set_maintenance_images_by_job',
  SET_MAINTENANCE_IMAGES_BY_JOB_LOADER_STATUS:
    'services/dashboards/maintenance/set_maintenance_images_by_job_loader_status',
  ADD_UPDATE_MAINTENANCE_JOB: 'services/dashboards/maintenance/add_update_maintenance_job',
  UPLOAD_MAINTENANCE_IMAGE: 'services/dashboards/maintenance/upload_maintenance_image',
  SET_UPLOAD_MAINTENANCE_IMAGE_LOADER_STATUS: 'services/dashboards/maintenance/upload_maintenance_image_loader_status',
  DELETE_MAINTENANCE_JOB: 'services/dashboards/maintenance/delete_maintenance_job',

  FETCH_PART_LIST_BY_PART_TYPE: 'services/dashboards/maintenance/fetch_part_list_by_part_type',
  SET_PART_LIST_BY_PART_TYPE: 'services/dashboards/maintenance/set_part_list_by_part_type',
};

const fetchMaintenanceDashboardData = ({ maintenanceDashboardParams }) => ({
  maintenanceDashboardParams,
  type: ActionTypes.FETCH_MAINTENANCE_DASHBOARD_DATA,
});

const setMaintenanceDashboardData = ({ maintenanceDashboardData }) => ({
  maintenanceDashboardData,
  type: ActionTypes.SET_MAINTENANCE_DASHBOARD_DATA,
});

const fetchMaintenanceJobs = () => ({
  type: ActionTypes.FETCH_MAINTENANCE_JOBS,
});

const setMaintenanceJobs = ({ maintenanceJobsData }) => ({
  maintenanceJobsData,
  type: ActionTypes.SET_MAINTENANCE_JOBS,
});

const fetchFactoryLabours = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_FACTORY_LABOURS,
});

const setFactoryLabours = ({ factoryLaboursData }) => ({
  factoryLaboursData,
  type: ActionTypes.SET_FACTORY_LABOURS,
});

const fetchFactoryDepartments = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_FACTORY_DEPARTMENTS,
});

const setFactoryDepartments = ({ factoryDepartmentsData }) => ({
  factoryDepartmentsData,
  type: ActionTypes.SET_FACTORY_DEPARTMENTS,
});

const fetchPartListByPartType = ({ partType }) => ({
  partType,
  type: ActionTypes.FETCH_PART_LIST_BY_PART_TYPE,
});

const setPartListByPartType = ({ partListData }) => ({
  partListData,
  type: ActionTypes.SET_PART_LIST_BY_PART_TYPE,
});

const fetchMaintenanceImagesByJob = ({ jobId }) => ({
  jobId,
  type: ActionTypes.FETCH_MAINTENANCE_IMAGES_BY_JOB,
});

const setMaintenanceImagesByJob = ({ maintenanceImagesListData }) => ({
  maintenanceImagesListData,
  type: ActionTypes.SET_MAINTENANCE_IMAGES_BY_JOB,
});

const setMaintenanceImagesByJobLoaderStatus = ({ maintenanceImageLoader }) => ({
  maintenanceImageLoader,
  type: ActionTypes.SET_MAINTENANCE_IMAGES_BY_JOB_LOADER_STATUS,
});

const addUpdateMaintenanceJob = ({
  actionType,
  maintenanceObj,
  maintenanceDashboardParams,
  factoryId,
  maintenanceImage,
}) => ({
  actionType,
  maintenanceObj,
  maintenanceDashboardParams,
  factoryId,
  maintenanceImage,
  type: ActionTypes.ADD_UPDATE_MAINTENANCE_JOB,
});

const uploadMaintenanceImage = ({ payload }) => ({
  payload,
  type: ActionTypes.UPLOAD_MAINTENANCE_IMAGE,
});

const setUploadMaintenanceImageLoaderStatus = ({ maintenanceUploadImageLoader }) => ({
  maintenanceUploadImageLoader,
  type: ActionTypes.SET_UPLOAD_MAINTENANCE_IMAGE_LOADER_STATUS,
});

const deleteMaintenanceJob = ({ maintenanceObj, maintenanceDashboardParams, factoryId }) => ({
  maintenanceObj,
  maintenanceDashboardParams,
  factoryId,
  type: ActionTypes.DELETE_MAINTENANCE_JOB,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

export default {
  fetchMaintenanceDashboardData,
  setMaintenanceDashboardData,
  fetchFactoryLabours,
  setFactoryLabours,
  fetchMaintenanceJobs,
  setMaintenanceJobs,
  fetchPartListByPartType,
  setPartListByPartType,
  fetchMaintenanceImagesByJob,
  setMaintenanceImagesByJob,
  setMaintenanceImagesByJobLoaderStatus,
  addUpdateMaintenanceJob,
  uploadMaintenanceImage,
  setUploadMaintenanceImageLoaderStatus,
  deleteMaintenanceJob,
  setLoader,
  fetchFactoryDepartments,
  setFactoryDepartments,
};
